import styled from 'styled-components';
import { MediaQueries } from '~/constants/constVars';
import { theme } from '~/styles/themes';

export const LaunchViewTopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: var(--client-height);
  margin-top: -60px;
  @media ${MediaQueries.desktop} {
    flex-direction: row;
    height: calc(var(--client-height) - 60px);
  }
`;

export const TrustPilotWidgetContainer = styled.div`
  background-color: ${theme.colors.backdrop};
  padding: 10px 0;

  @media ${MediaQueries.tablet} {
    padding: 20px 0;
  }
`;
